import { useRef, useEffect } from 'react';

// TODO: How to test usePrevious custom hook
const usePrevious = value => {
  const ref = useRef();

  useEffect(() => {
    ref.current = value;
  }, [value]);

  return ref.current;
};

export default usePrevious;
